import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../_gori/helpers'
import {MapView} from './MapView'
import {textByCount} from '../../../../../_gori/utils'
import {SmartA1BatchesWithPoints} from '../../definitions'
import {useCallback, useState} from 'react'
import {useA1BatchHelper} from '../../hooks'

export const CreateSmartA1Batch = ({data}: {data: SmartA1BatchesWithPoints}) => {
  const intl = useIntl()
  const {downloadA1Batch} = useA1BatchHelper()
  const [downloadingIds, setDownloadingIds] = useState<string[]>([])

  const getPoint = useCallback(
    (warehouseId: string) => {
      return data.points.find((point) => point.id.toString() === warehouseId.toString())
    },
    [data.points]
  )

  const handleDownloadA1Batch = useCallback(
    async (id?: string) => {
      const downloadKey = id || 'all'
      const batchIds = id ? [id] : data.batches.map((b) => b.batch.id)
      const batchName = id
        ? data.batches.find((b) => b.batch.id === id)?.batch.name
        : data.batches[0]?.batch.name

      setDownloadingIds((prev) => [...prev, downloadKey])
      await downloadA1Batch({
        batchIds,
        batchName,
      })
      setDownloadingIds((prev) => prev.filter((k) => k !== downloadKey))
    },
    [data.batches, downloadA1Batch]
  )

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center mb-6'>
        <div className='d-flex justify-content-between mt-4'>
          <span className={clsx('text-gori fw-bolder fs-3')}>
            {intl.formatMessage(
              {
                id:
                  data.batches.length <= 1
                    ? 'SUCCESSFULLY_CREATED_NEW_A1_BATCH'
                    : 'SUCCESSFULLY_CREATED_NEW_A1_BATCHES',
              },
              {count: data.batches.length}
            )}
          </span>
          <KTSVG
            path='/media/gori/a1/verify.svg'
            className={clsx('svg-icon svg-icon-1 ms-2 text-primary')}
          />
        </div>
        <div
          onClick={() => !downloadingIds.includes('all') && handleDownloadA1Batch()}
          className={clsx(
            'd-flex gap-2 ps-2 pe-3 pt-2 pb-2 border border-gray-300 rounded-2',
            downloadingIds.includes('all')
              ? 'cursor-no-drop opacity-50'
              : 'cursor-pointer bg-hover-light-primary'
          )}
        >
          {downloadingIds.includes('all') ? (
            <span className='spinner-border spinner-border-sm align-middle mt-1' />
          ) : (
            <KTSVG path='/media/gori/batches/file_download_2.svg' className='svg-icon-1' />
          )}
          <span className='fs-6 fw-bold'>
            {intl.formatMessage({id: 'DOWNLOAD_ALL_BATCH_LISTS'})}
          </span>
        </div>
      </div>
      <div
        style={{maxHeight: '60vh', minHeight: '20vh', overflowY: 'auto'}}
        className='d-flex gap-6 flex-column pe-2'
      >
        {data.batches.map((item) => {
          const point = getPoint(item.warehouse.id)
          return (
            <div
              key={item.batch.id}
              className='border border-gray-300 rounded-4 d-flex px-10 py-4 d-flex justify-content-center align-items-center gap-6'
            >
              {point ? (
                <MapView
                  id={point?.id || ''}
                  points={[point]}
                  selected={point?.title || ''}
                  size='sm'
                  zoomable={false}
                />
              ) : (
                <div className='w-200px' />
              )}

              <div className='d-flex flex-column gap-3 justify-content-center'>
                <h2 className='text-dark'>{item.batch.name}</h2>
                <div className='fs-6'>
                  {item.warehouse.air_port} ({item.warehouse.state} {item.warehouse.city}{' '}
                  {item.warehouse.country})
                </div>
                <div className='fs-6'>
                  {item.total_orders}{' '}
                  {textByCount(
                    item.total_orders,
                    intl.formatMessage({id: 'ORDER_INCLUDED'}),
                    intl.formatMessage({id: 'ORDERS_INCLUDED'})
                  )}
                </div>
              </div>
              <div
                className={clsx(
                  'w-40px h-40px d-flex justify-content-center align-items-center border border-gray-300 rounded-2 ms-auto',
                  downloadingIds.includes(item.batch.id)
                    ? 'cursor-no-drop opacity-50'
                    : 'cursor-pointer bg-hover-light-primary'
                )}
                onClick={() =>
                  !downloadingIds.includes(item.batch.id) && handleDownloadA1Batch(item.batch.id)
                }
              >
                {downloadingIds.includes(item.batch.id) ? (
                  <span className='spinner-border spinner-border-sm align-middle' />
                ) : (
                  <KTSVG path='/media/gori/batches/file_download_2.svg' className='svg-icon-1' />
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
